import AuthBase from "../views/Auth/AuthBase.vue";
import Login from "../views/Auth/Login.vue";
import Logout from "../views/Auth/Logout.vue";
import Signup from "../views/Auth/Signup.vue";

export default {
  path: "/auth",
  component: AuthBase,
  children: [
    {
      path: "",
      redirect: "/auth/login",
    },
    {
      path: "login",
      name: "Login",
      meta: {
        auth: false
      },
      component: Login
    },
    {
      path: "signup",
      name: "Signup",
      meta: {
        auth: false
      },
      component: Signup
    },
    {
      path: "logout",
      name: "Logout",
      meta: {
        auth: true
      },
      component: Logout
    },
  ]
};
